module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Resize', {
    ref: "app",
    staticClass: "app-layout",
    attrs: {
      "id": "app"
    }
  }, [_c('menu-app', {
    attrs: {
      "menuClass": _vm.menuClass
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "id": "content"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    ref: "page",
    attrs: {
      "supportsWEBP": _vm.supportsWEBP,
      "bg": _vm.getCurrentBg
    },
    on: {
      "changeMenuClass": _vm.changeMenuClass
    }
  })], 1)], 1), _vm._v(" "), (_vm.$root.isMobile) ? _c('a', {
    staticClass: "to-top",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toTop($event)
      }
    }
  }, [_c('to-top')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dced5584","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 649
// module chunks = 1